<script setup lang="ts">
</script>

<template>
  <h2 class="text-lg leading-6 font-medium text-gray-900">
    <slot />
  </h2>
</template>
